module.exports = __webpack_public_path__ + "media/PtownConCommHearing20191217_1.1c9bc78d.mp4";